import gql from "graphql-tag"

const PUBLISH_ORDERS = gql`
  mutation PublishOrders($input: MutationPublishOrdersInput!) {
    publishOrders(input: $input) {
      isError
      isAddedMemoryRoom
      isPublishMemoryRoom
      isPublishMemoryRoomError
      publishMemoryRoomErrorText
      resultText
      resultIcon
      errorReason
      resultOrders {
        success
        resultIcon
        resultText
        order {
          id
          mediaOrder {
            edit {
              userInterface {
                editStatusIcon
                editStatusText
                publishButtonText
              }
            }
            isLocked
            status {
              color
              status
            }
            publishConversation {
              isBookingSent
            }
          }
        }
      }
    }
  }
`

export default PUBLISH_ORDERS
